import * as activityConstants from "../constants/activityConstants";

export const activitiesReducer = (
  state = { loading: true, activities: [], type: "NOTHING_HAPPENED" },
  action
) => {
  switch (action.type) {
    case activityConstants.ACTIVITY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        type: activityConstants.ACTIVITY_LIST_REQUEST,
      };
    case activityConstants.ACTIVITY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        activities: action.payload.data,
        type: activityConstants.ACTIVITY_LIST_SUCCESS,
      };
    case activityConstants.ACTIVITY_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        type: activityConstants.ACTIVITY_LIST_FAIL,
      };
    case activityConstants.ACTIVITY_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        type: activityConstants.ACTIVITY_DETAILS_REQUEST,
      };
    case activityConstants.ACTIVITY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        activityLink: action.payload.data.activityLink,
        type: activityConstants.ACTIVITY_DETAILS_SUCCESS,
      };
    case activityConstants.ACTIVITY_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        type: activityConstants.ACTIVITY_DETAILS_FAIL,
      };
    case activityConstants.ACTIVITY_DELETE_REQUEST:
      return {
        ...state,
        loading: true,
        type: activityConstants.ACTIVITY_DELETE_REQUEST,
      };
    case activityConstants.ACTIVITY_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        type: activityConstants.ACTIVITY_DELETE_SUCCESS,
      };
    case activityConstants.ACTIVITY_DELETE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.data,
        type: activityConstants.ACTIVITY_DELETE_FAIL,
      };
    case activityConstants.ACTIVITY_UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
        type: activityConstants.ACTIVITY_UPDATE_REQUEST,
      };
    case activityConstants.ACTIVITY_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        type: activityConstants.ACTIVITY_UPDATE_SUCCESS,
      };
    case activityConstants.ACTIVITY_UPDATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        type: activityConstants.ACTIVITY_UPDATE_FAIL,
      };
    case activityConstants.ACTIVITY_CREATE_REQUEST:
      return {
        ...state,
        loading: true,
        type: activityConstants.ACTIVITY_CREATE_REQUEST,
      };
    case activityConstants.ACTIVITY_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        type: activityConstants.ACTIVITY_CREATE_SUCCESS,
      };
    case activityConstants.ACTIVITY_CREATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        type: activityConstants.ACTIVITY_CREATE_FAIL,
      };
    default:
      return state;
  }
};
